import {Component, OnInit} from '@angular/core';
import {PortalService} from "../../services/portal.service";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {ActivatedRoute, Router} from "@angular/router";
import {FoerdermittelcheckAnfrage} from "../anfrage/foerdermittelcheck.anfrage";
import {FoerdermittelcheckRequestService} from "../services/request.service";

/**
 * Component for the entry of the foerdermittelcheck. Let the user select its interests.
 */
@Component({
    selector: 'app-foerdermittelcheck-einstieg',
    templateUrl: './einstieg.component.html',
    standalone: false
})
export class EinstiegComponent implements OnInit {

  /**
   * textkeyprefix
   */
  textkeyprefix: string = 'foerdermittelcheck.einstieg.';

  /**
   * placeholder for portalname in welcome text
   */
  welcomePlaceholder: any = {};

  /**
   * the current userdata
   */
  anfrage: FoerdermittelcheckAnfrage;

  /**
   * Toggle for showing the error if no option is selected
   */
  showError: boolean = false;

  /**
   * constructor
   * @param portalService
   * @param router
   * @param activatedRoute
   * @param requestService
   */
  constructor(private portalService: PortalService, private router: Router, private activatedRoute: ActivatedRoute, private requestService: FoerdermittelcheckRequestService) {
  }

  ngOnInit() {
    // get the anfrage from the local cache
    this.anfrage = this.requestService.getAnfrage();

    // init Placeholder
    this.welcomePlaceholder = {
      portalPlaceholder: this.portalService.getConfig('embed.portal.welcometext') ?
        (' ' + this.portalService.getConfig('embed.portal.welcometext')) : ''
    }

  }

  /**
   * The form is submitted
   */
  onSubmit(): void {
    if(this.anfrage?.gefoerdertWird?.length > 0) {
      this.saveData();

      //check in which path we are and set global variable
      window['focPath'] = (this.anfrage?.gefoerdertWird?.length === 1 && this.anfrage?.gefoerdertWird[0] === 'elektromobilitaet') ? 'elektro' : 'bau';

      //show the next step
      this.nextStep();
    }
  }

  /**
   * save the selection of interests
   */
  saveData(): void {
    this.requestService.setAnfrage(this.anfrage);

    // save to server
    this.requestService.saveDataToServer();
  }

  /**
   * move to the next step
   */
  nextStep(): void {
    // forward to first chapter
    this.router.navigate(['../eingabe/foerdernehmer/basisinformationen/1'], {
      relativeTo: this.activatedRoute
    });
  }

  /**
   * Eventhandler if a interest is changed
   * @param event
   */
  selectInterest(event: Event): void {
    // get the current value of changed checkbox
    const checkbox = event.target as HTMLInputElement;
    const value = checkbox?.value;
    const checked = checkbox?.checked;

    if(checked === true) {
      // add checked element to list
      this.anfrage?.gefoerdertWird?.push(value);

      // remove altbau if neubau and other way around
      ['altbau', 'neubau'].forEach(type => {
        if(value === type) {
          const otherType = type === 'altbau' ? 'neubau' : 'altbau';
          this.anfrage.gefoerdertWird = this.anfrage?.gefoerdertWird?.filter(element => element !== otherType);
        }
      });
    }
    else {
      // remove unchecked element from list
      this.anfrage.gefoerdertWird = this.anfrage?.gefoerdertWird?.filter(element => element !== value);
    }
  }

  /**
   * Click on the submit button
   */
  onSubmitClick(): void {
    if(this.anfrage?.gefoerdertWird?.length <= 0) {
      this.showError = true;
    }
  }

}
